import { create as actualCreate } from 'zustand'
import type { StateCreator } from 'zustand'

const storeResetFns = new Set<() => void>()

// Global function to clear all stores
export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => resetFn())
}

// Custom create wrapper that registers a reset function for every store
export const create = (<T>(stateCreator: StateCreator<T>) => {
  const store = actualCreate(stateCreator)
  const initialState = store.getInitialState()

  storeResetFns.add(() => {
    store.setState(initialState, true) // 'true' replaces the entire state
  })

  return store
}) as typeof actualCreate